import { Backdrop, Portal } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { DragIndicator, List } from '@material-ui/icons/';
import { SpeedDial, SpeedDialAction, SpeedDialIcon } from '@material-ui/lab/';
import React from 'react';
import { useHistory } from 'react-router-dom';
import { useSpeedDial } from '../../../hooks';


const useStyles = makeStyles((theme) => ({
  root: {
    transform: 'translateZ(0px)',
    flexGrow: 1,
  },
  speedDial: {
    position: 'absolute',
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
  backdrop: {
    // position: 'absolute',
    // backgroundColor: 'yellow',
    // zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));

export default function SpeedDialTooltipOpen() {
  const { RouteSpeedDial } = useSpeedDial()
  const classes = useStyles();
  let history = useHistory();
  const [open, setOpen] = React.useState(false);

  const handleOpenClose = () => {
    setOpen(!open)
  }

  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  }

  const handleLink = (path) => {
    history.push(`${path}`)
  }

  return (
    <Portal>
      <SpeedDial
        ariaLabel="SpeedDial"
        className={classes.speedDial}
        icon={<SpeedDialIcon openIcon={<List />} icon={<DragIndicator />} />}
        style={{ cursor: 'pointer', position: 'fixed', bottom: '2.5rem' }}
        onClose={handleClose}
        onOpen={handleOpen}
        open={open}
      >
        <Backdrop className={classes.backdrop} onClick={handleOpenClose} open={open} />
        {RouteSpeedDial?.map((row, i) => (
          <SpeedDialAction
            key={row?.name}
            icon={row?.icon}
            tooltipTitle={row?.name}
            tooltipOpen
            onClick={() => handleLink(row?.path)}
          />
        ))}
      </SpeedDial>
    </Portal>
  );
}
